import React, { useState, useEffect, useRef,Component  } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, Upload,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    LoadingOutlined
} from '@ant-design/icons';

import './styles.scss'



import moment from 'moment'
import {getData,editItem,addItem,deleteItem,getOptions,UploadPicture} from '../../../Redux/actions/crudActions'
import {errorParser} from '../../../utils/helpers'
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

// console.log(ClassicEditor.builtinPlugins.map( plugin => plugin.pluginName ));

const Index = ({value,onChange,currentProduct}) => { 
    
    const dispatch = useDispatch()    
    const siteEditorRef = useRef(null);
    const { } = useSelector(
      state => ({
      
      }),
      shallowEqual
    )


    const [currentValue, setCurrentvalue] = useState(0)
    const [currentValueDisplay, setCurrentvalueDisplay] = useState(0)

    const [currentUnit, setCurrentUnit] = useState(null)




    useEffect(() => {  
    
      if(currentProduct){     
        setCurrentUnit(currentProduct.unit)
        if(value){     
          setCurrentvalue(value)
          setCurrentvalueDisplay(value)
        }  
      }  
    }, [currentProduct])

    const changetheunit =(cu) =>{
      if(cu == currentProduct.unit){
        setCurrentvalue(currentValue)
        setCurrentvalueDisplay(currentValue)
        setCurrentUnit(currentProduct.unit)
        onChange(currentValue)
      }
      if(currentProduct.second_unit && currentProduct.second_unit_rate  && parseFloat(currentProduct.second_unit_rate > 0)){
        if(cu == currentProduct.second_unit){
          var newcalc =parseFloat(currentValue)*parseFloat(currentProduct.second_unit_rate)
     
          setCurrentvalue(currentValue)
          setCurrentvalueDisplay(newcalc)
          setCurrentUnit(currentProduct.second_unit)
          onChange(currentValue)
        }
      }
    }

    const valuechange =(va) =>{
    
      if(currentUnit == currentProduct.unit){
        setCurrentvalue(va)
        setCurrentvalueDisplay(va)  
        onChange(va)
      }
   
      if(currentUnit == currentProduct.second_unit){
        var newcalc =parseFloat(va)/parseFloat(currentProduct.second_unit_rate)    
        setCurrentvalue(newcalc)
        onChange(newcalc)
        setCurrentvalueDisplay(va)    
      }
      
    }
    
    const selectAfter = (
      <Select defaultValue={currentProduct.unit} className="select-after" onChange={e=>{changetheunit(e)}}>
        <Option value={currentProduct.unit}>{currentProduct.unit}</Option>       
        {currentProduct.second_unit_rate  && parseFloat(currentProduct.second_unit_rate)  > 0?
          <Option value={currentProduct.second_unit}>{currentProduct.second_unit}</Option>
        :null}
      </Select>
    );



    return ( 
  
      <Input 
        type={"number"} 
        value={currentValueDisplay}
        onChange={(e)=>{valuechange(e.target.value)}}
        addonAfter={selectAfter}
        min={0}
      />
    
 
     )
}
  
export default Index
  